module.exports = __webpack_public_path__ + "static/media/Resume.10808567.pdf";